export enum deliveryMode {
  DROP_OFF = 'DROP_OFF', // C揽
  B_DROP_OFF = 'B_DROP_OFF', // B揽
  TRANSPORT = 'TRANSPORT', // 二程接驳
}
